import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-tour',
  templateUrl: './video-tour.component.html',
  styleUrls: ['./video-tour.component.css']
})
export class VideoTourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
